import { Action, ActionReducer } from '@ngrx/store';

import { AppState } from '@core/state/interfaces';

import { AuthActions } from '@auth/state';

export function clearState(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return function (state: AppState, action: Action): AppState {
    // reset the state when explicitly requested
    if (action.type === AuthActions.ResetState.type) {
      return reducer(undefined, action);
    }

    // reset the state if logging on as a different user
    if (action.type === AuthActions.Login.type) {
      if (!!state?.auth?.user?.nameid && (action as any).username?.toUpperCase() !== state?.auth?.user?.nameid?.toUpperCase()) {
        return reducer(undefined, action);
      }
    }

    return reducer({ ...state }, action);
  };
}
